module.exports = __webpack_public_path__ + "img/step6-03.205aaacc.jpg";